export default "__VITE_ASSET__A4nZ$93q__"